
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import ParamPriceFieldAppService from "@/apis.machine/ParamPriceFieldAppService";
import DtoFormParamPriceField, {
  DtoFormParamPriceFieldMiezzFormItems,
  DtoFormParamPriceFieldRules,
} from "@/models.machine/DtoFormParamPriceField";

export default class ParamPriceFieldForm extends Vue {
  @Model() modelValue!: MiezzModal;
  @Prop() id?: string;

  form = new MiezzForm<DtoFormParamPriceField, string>();

  created(): void {
    //表单-数据-初始化
    this.form.Data = new DtoFormParamPriceField();
    //表单-校验
    this.form.Rules = DtoFormParamPriceFieldRules;
    //表单-元素配置
    this.form.Items = DtoFormParamPriceFieldMiezzFormItems;

    //修改元素配置
    //for (const item of this.form.Items) {
    //  switch (item.Prop) {
    //    default:
    //      break;
    //  }
    //}

    this.modelValue.Width = "70%";
    this.modelValue.HandleClick = this.handleClick;
    this.modelValue.Buttons = [
      {
        Code: "submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];

    this.handleGet();
  }

  /**查询表单数据 */
  handleGet(): void {
    if (this.id) {
      ParamPriceFieldAppService.GetById(this.id).then((r) => {
        if (r.data.Data) this.form.Data = r.data.Data;
      });
    }
  }

  handleAdd(): void {
    this.form.Data.Children?.push({});
  }

  handleDelete(index: number): void {
    this.form.Data.Children?.splice(index, 1);
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "submit":
        MiezzForm.submit(this.$refs, "ruleForm", (v) => {
          if (v) {
            ParamPriceFieldAppService.Post(this.form.Data)
              .then(() => {
                this.handleSubmit();
                complete();
              })
              .catch(complete);
          } else complete();
        });
        break;
      default:
        break;
    }
  }

  /**表单提交-回调 */
  @Emit()
  handleSubmit(): void {
    //
  }
}
